'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StickyToggleButton = require('./components/StickyToggleButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StickyToggleButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/sticky-toggle-button/index.js
// module id = 1068
// module chunks = 1